<!--<link rel="stylesheet" href="../../../../ujcms/src/main/webapp/templates/1/default/_files/css/index.css">-->
<template>
  <div>
    <!--轮播图-->
    <div class="bgBox">
      <img src="../../assets/img/aboutUs/sjxt.png" class="d-block">
    </div>

    <!--公司简介-->
    <div class="introduction-index">
      <div class="container">
        <div class="row pt-5">
          <div class="col col-lg-6 p-4">
            <div class="introduction-index-title">
              <b>公司简介</b>
              <span>COMPANY  PROFILE</span>
            </div>
            <p class="mt-2" v-html="introduction.content"></p>
          </div>
          <div class="col col-lg-6 mt-3">
            <video controls :src="videoUrl" style="width:100%;">
              <source />
              <p>抱歉，您的浏览器不支持该视频格式。</p >
            </video>
          </div>
        </div>
      </div>
    </div>

    <!--荣誉资质-->
    <div class="col col-lg-12 bg-colorFBFAFF" style="padding: 70px 0 30px 0;">
      <div class="container mb-5">
        <div class="introduction-index-title mb-4">
          <b>荣誉资质</b>
          <span>HONORARY  QUALIFICATIONS</span>
        </div>
        <div class="row qualifications-list">
          <swiper :options="swiperOption" ref="mySwiper" style="height: 150px;">
            <!-- slides -->
            <swiper-slide v-for="item in qualificationsList" :key="item.cid">
              <img :src="filePathPrefix + item.pic" class="d-block" style="height: 140px;"/>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <!--<div class="swiper-scrollbar"   slot="scrollbar"></div>-->
          </swiper>
        </div>
      </div>
    </div>

    <!--联系我们-->
    <div class="col col-lg-12" style="padding: 70px 0 0px 0;">
      <div class="container">
        <div class="introduction-index-title mb-4">
          <b>联系我们</b>
          <span>CONTACT US</span>
        </div>
        <div class="row contactUs-box">
          <div>
            <baidu-map class="bm-view" :center="center" :zoom="16" ak="nPlU5tsqxLU0ohj0SkwDilkcb8GG15AT">
              <bm-marker :position="{lng: '106.228808', lat: '38.446375'}"></bm-marker>
            </baidu-map>
          </div>
          <div class="contactUs-text">
            <span>联系我们</span>
            <p>
              <img src="../../assets/img/aboutUs/24gf-telephone2.png" height="15">
              <span>0951-5177072</span>
            </p>
            <p>
              <img src="../../assets/img/aboutUs/diqiu.jpg" height="15">
              <span>http://www.ccxb315.com/</span>
            </p>
            <p>
              <img src="../../assets/img/aboutUs/youjian.png" height="15">
              <span>http://www.ccxb315.com/</span>
            </p>
            <p>
              <img src="../../assets/img/aboutUs/loupanshuju.png" height="15">
              <span>宁夏回族自治区银川市金凤区宁安大街490号</span>
            </p>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Swiper from "swiper";
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import { getIndexPicDOList, getNewsDOList, getColumnTreeList } from "@/api/index";
var axios = require('axios')
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      videoUrl: 'http://47.112.159.67:9999/files/c731eddd-e3b1-412a-893b-249b01e31839.mp4',
      indexPicDOList: [],
      introduction: {},
      newsList: [],
      productAction: 0,
      productList: [],
      solutionAction: 0,
      solutionList: [],
      solutionItem: {},

      swiperOption: { //更多的参数的配置看swiper4官网介绍：http://www.swiper.com.cn/api/navigation/210.html
        autoplay: {
          delay: 1000,//1秒切换一次
        },
        loop:true,
        slidesPerView: 5,
        // slidesPerGroup : 5,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // autoHeight: true,
        height: 140,//你的slide高度
      },
      qualificationsList: [],
      successCasesAction: 0,
      successCasesList: [],
      center: {lng: 106.228808, lat: 38.446375},

    }
  },
  mounted() {
    getNewsDOList({limit: 40,offset:0,type: 20}).then(response => {
      this.qualificationsList = response.rows;
    });
    getNewsDOList({limit:1,offset:0,type: 17}).then(response => {
      this.introduction = response.rows[0];
      this.videoUrl = this.filePathPrefix + this.introduction.pic;
      document.querySelector("video").load();
    });
  },
  methods: {
    /*公司产品*/
    mouseOverProduct(index){
      this.productAction = index;
    },
    mouseOutProduct(index){
      this.productAction = null;
    },
    /*成功案例*/
    mouseOverSuccess(index){
      this.successCasesAction = index;
    },
    mouseOutSuccess(index){
      this.successCasesAction = null;
    },
    getsolutionItem(id){
      getNewsDOList({limit:1,offset:0,type: id}).then(response => {
        this.solutionItem = response.rows[0];
      });
    },
    solutionClick(row,index){
      this.solutionAction = index;
      this.getsolutionItem(row.id)
    },
  },
}

</script>

<style lang="less">
.contactUs-box{
  display: flex;
  &>div{
    width: 50%;
    height: 300px;
  }
  .bm-view{
    width: 100%;
    height: 300px;
  }
}
.contactUs-text{
  width: 50%;
  background: #fbfaff;
  padding: 40px 20px 40px 60px;
  &>span{
    font-size: 17px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 600;
    text-align: left;
    color: #2d2d2d;
    display: block;
    padding-bottom: 20px;
  }
  &>p{
    display: flex;

    &>img{
      margin-top: 14px;
      margin-right: 10px;
    }
    &>span{
      dispaly: block;
      font-size: 14px;
      font-family: Arial, Arial-Regular;
      font-weight: 400;
      text-align: left;
      color: #404040;
      line-height: 45px;
    }
  }
}
.bgBox{
  background: url("../../assets/img/aboutUs/bgimg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 450px;
  position: relative;
  &>img{
    width: 300px;
    height: 45px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.bg-colorFBFAFF{
  background: #FBFAFF;
}
.swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
  height: 140px;
}
.swiper-slide{
  width: 100%;
  border: 5px solid #2767BE;
}
.swiper-pagination-bullet {
  width: 15px;
  height: 15px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 8%;
}
.qualifications-list {
  img{
    min-width: 200px;
    width: 100%;
  }
}

.introduction-index{
  background-image: url("../../assets/img/index/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.introduction-index-title > b{
  font-size: 1.3rem;
  padding-right: 10px;
}
.introduction-index-title > span{
  font-size: 0.9rem;
  color: #043B86;
}

.introduction-index{
  /*background-image: url("../img/index/bg1.png");*/
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  min-height: 420px;
}
.introduction-index-title > b{
  font-size: 1.3rem;
  padding-right: 10px;
}
.introduction-index-title > span{
  font-size: 0.9rem;
  color: #043B86;
}
.carousel-caption2{
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  color: #fff;
  background: rgba(0,0,0,0.7);
  padding: 10px;
  font-size: 12px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
}
.carousel-caption2>p{
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 超出几行省略 */
  overflow: hidden;
}
.news-tab{
  display: flex;
  border-bottom: 2px solid rgba(255,255,255,0.7);
  line-height: 40px;
  justify-content: space-between;
  padding: 0 10px;
}
.news-tab> div{
  width: 80px;
  text-align: center;
  position: relative;
  cursor: pointer;
  color: rgba(255,255,255,0.7);
}
.news-tab> div > img{
  /*width: 80px;*/
  position: absolute;
  bottom: -6px;
}
.news-tab-action{
  color: #fff !important;
}
.news-list{
  list-style-type: none;
  margin: 0;
  padding: 10px;
  color: #fff;
}
.news-list li{
  padding-bottom: 10px;
  padding-top: 5px;
}
.news-list label{
  display: block;
  font-size: 13px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  margin: 5px;
  &>b{
    font-size: 18px;
    padding-right: 5px;
  }
}
.news-list p{
  display: block;
  font-size: 12px;
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 20px;
  color: rgba(255,255,255,.7);
}
.product-list{
  margin-top: 20px;
}
.product-list > div{
  padding: 15px;
  height: 200px;
  overflow: hidden;
}
.product-list > div > label{
  display: block;
  font-size: 15px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  margin: 0;
}
.product-list > div > p{
  display: block;
  font-size: 13px;
  line-height: 20px;
  color: #404040;
  margin-top: 5px;
}
.product-action{
  background: #0F4B9E;
  color: #fff !important;
}
.product-action > p{
  color: #fff !important;
}
.solution-box{
  background: #FBFAFF;
}
.solution-left{
  background: #F5F5FD;
  padding: 0;
}
.solution-left>span{
  display: block;
  text-align: center;
  line-height: 45px;
  cursor: pointer;
}
.solution-action{
  background: #0F4B9E;
  color: #fff;
}
.solution-right{
  background: #F5F5FD;
  height: 180px;
  overflow: hidden;
}
.solution-right-con>label{
  font-size: 16px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
  text-align: left;
  color: #404040;
  display: block;
}
.solution-right-con>p{
  font-size: 13px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #404040;
  margin-top: 5px;
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.solution-right-con>span{
  font-size: 13px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
  color: #0F4B9E;
  display: inline-block;
  border: 1px solid #0f4b9e;
  float: right;
  width: 110px;
  text-align: center;
  line-height: 25px;
  margin-top: 15px;
  cursor: pointer;
}
.solution-right-con>span:hover{
  background: #0f4b9e;
  color: #fff;
}
.successCases-listItme{
  height: 170px;
  position: relative;
}
.successCases-listItme>img{
  position: absolute;
}
.successCases-listItme>span{
  margin: 0 20px;
  font-size: 15px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content:center;
  align-items:Center;
  height: 170px;
  position: absolute;
}
.successCases-listItme-con{
  background: #0F4B9E;
  height: 170px;
  top: 0;
  color: #fff;
  display: none;
}
.successCases-listItme-con>label{
  font-size: 16px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
  text-align: left;
  display: block;
}
.successCases-listItme-con>p{
  font-size: 13px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  margin-top: 5px;
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.successCases-listItme-con>span{
  font-size: 13px;
  font-family: SimHei, SimHei-Regular;
  font-weight: 400;
  color: #fff;
  display: inline-block;
  border: 1px solid #fff;
  float: right;
  width: 90px;
  text-align: center;
  line-height: 25px;
  margin-top: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/index.vue